export default {
	api: {
		operationSuccess: 'Operasi Berhasil',
		operationFailed: 'Operasi Gagal',
		errorTip: 'Kesalahan Petunjuk',
		successTip: 'Petunjuk Berhasil',
		errorMessage: 'Operasi gagal, sistem tidak normal',
		timeoutMessage: 'Waktu masuk telah habis, silahkan masuk kembali',
		apiTimeoutMessage: 'Waktu permintaan telah habis, silahkan muat ulang halaman dan coba kembali',
		apiRequestFailed: 'Waktu permintaan gagal, silahkan mengulang kembali nanti!',
		networkException: 'Anomali Jaringan',
		networkExceptionMsg: 'Silahkan periksa jika koneksi jaringan anda normal! Jaringan tidak normal.',

		errMsg401: 'Pengguna tidak memiliki izin (token, nama pengguna, kesalahan kata sandi)',
		errMsg403: 'Pengguna sudah di otorisasi, namun akses dilarang!',
		errMsg404: 'Permintaan jaringan gagal, sumber tidak ditemukan!',
		errMsg405: 'Permintaan jaringan gagal, metode permintaan tidak diizinkan!',
		errMsg408: 'Permintaan jaringan telah habis',
		errMsg500: 'Kesalahan server, silahkan hubungi admin!',
		errMsg501: 'Jaringan belum diaktifkan!',
		errMsg502: 'Jaringan gagal',
		errMsg503: 'Layanan tidak tersedia, server sedang sibuk sementara atau dalam perawatan!',
		errMsg504: 'Koneksi Terputus',
		errMsg505: 'Versi http tidak mendukung permintaan ini!',
		logoutTip: 'Pengingat',
		logoutMessage: 'Konfirmasi keluar dari sistem',
		menuLoading: 'Menu sedang dimuat'
	},
	errorLog: {
		tableTitle: 'Daftar kesalahan Log',
		tableColumnType: 'Jenis',
		tableColumnDate: 'Waktu',
		tableColumnFile: 'Berkas',
		tableColumnMsg: 'Pesan Gagal',
		tableColumnStackMsg: 'Tumpukan Informasi',
		tableActionDesc: 'Rincian',
		modalTitle: 'Rincian Kesalahan',
		fireVueError: 'Kesalahan yang dipicu oleh vue',
		fireResourceError: 'Kesalahan yang dihasilkan oleh sumber daya',
		fireAjaxError: 'Gagal mengirim pesan ke server melalui ajax',
		enableMessage: 'Opsi yang ada di /src/settings/projectSetting.ts tidak diperlukan',
		exception: {
			backLogin: 'Kembali Masuk',
			backHome: 'Kembali Ke Beranda',
			subTitle403: 'Maaf, anda tidak memiliki akses ke halaman ini',
			subTitle404: 'Maaf, halaman yang Anda kunjungi tidak ada.',
			subTitle500: 'Maaf, server melaporkan kesalahan.',
			noDataTitle: 'Tidak ada data dalam halaman ini.',
			networkErrorTitle: 'Jaringan Gagal',
			networkErrorSubTitle: 'Maaf, koneksi anda sudah terputus, silahkan periksa kembali jaringan anda!',
		},
		lock: {
			unlock: 'Klik untuk membuka kunci',
			alert: 'Kesalahan kata sandi layar kunci',
			backToLogin: 'Kembali ke masuk',
			entry: 'Masuk ke sistem',
			placeholder: 'Silahkan masukan kata sandi layar kunci atau kata sandi pengguna',
		},
		login: {
			backSignIn: 'Kembali masuk',
			mobileSignInFormTitle: 'Masuk melalui ponsel',
			qrSignInFormTitle: 'Masuk melalui kode QR',
			signInFormTitle: 'Masuk',
			signUpFormTitle: 'Daftar',
			forgetFormTitle: 'Atur ulang kata sandi',
			signInTitle: 'Sistem Manajemen Backend',
			signInDesc: 'Masukan informasi pribadi dan mulai!',
			policy: 'Saya setuju dengan XXXX Kebijakan Privasi.',
			scanSign: 'Memindai kode untuk menyelesaikan masuk',
			loginButton: 'Masuk',
			registerButton: 'Daftar',
			rememberMe: 'Ingatkan saya',
			forgetPassword: 'Lupa kata sandi?',
			otherSignIn: 'Masuk dengan',
			// notify
			loginSuccessTitle: 'Berhasil Masuk',
			loginSuccessDesc: 'Hai! Selamat datang di Sistem Polaris',

			// placeholder
			accountPlaceholder: 'Silahkan masukan nama pengguna',
			passwordPlaceholder: 'Silahkan masukan kata sandi',
			smsPlaceholder: 'Silahkan masukan kode SMS',
			mobilePlaceholder: 'Silahkan masukan Ponsel',
			policyPlaceholder: 'Daftar setelah melakukan pemeriksaan',
			diffPwd: 'Ke dua kata santi tidak sesuai',
			userName: 'Nama Akun',
			password: 'Kata Sandi',
			confirmPassword: 'Konfirmasi kata sandi',
			email: 'Email',
			smsCode: 'Kode Pesan SMS',
			mobile: 'Ponsel',
			yuanMiMa: 'Kata sandi lama',
			xinMiMa: 'Kata sandi baru',
		},
		queRenMiMa: '确认密码',
		xiuGaiYongHuMiMa: '修改用户当前密码',
		xiTongGuanLi: 'Pengaturan Sistem',
		yunYingYongHuGuanLi: '运营用户管理',
		keHuYongHuGuanLi: '客户用户管理',
		souSuoNeiRong: 'Manajemen Pengguna',
		yongHuZhangHao: 'Akun',
		qingshuruyonghuzhanghao: 'Masukan Akun Pengguna',
		yongHuXingMing: 'Orang',
		qingshuruyongHuXingMing: 'Masukan Pengguna',
		lianXiDianHua: 'Nomor Telepon',
		qingshuruyonghushoujihao: 'Masukan Nomor Telepon Pengguna',
		keHujiancheng: '客户简称',
		qingshuruyonghuzhaungtai: 'Masukan Status Pengguna',
		yongHuZhuangTai: 'Status',
		zuiHouDengLuShiJian: 'Masuk Terakhir',
		zaiZhi: 'Aktif',
		fuzhi: 'Salin',
		liZhi: 'Tidak Aktif',
		xingBie: 'Jenis Kelamin',
		nan: 'P',
		nv: 'W',
		tiShi: 'Petunjuk',
		xuHao: '序号',
		queDingLizhi: '确定设定该用户离职吗',
		queDingZaiZhi: '确定设定该用户在职吗',
		queDingDelete: '确定删除该客户么',
		queDingQiyong: '确定启用该客户么',
		zhuangTai: '状态',
		constract: ' Nomor Kontak',
		managerNumber: '管理员账号',
		chongZhiMiMa: 'Atur ulang kata sandi',
		quedingyaofuzhigaiyonghuma: '确定复制该用户吗?',
		quedingyaobianjigaiyonghuma: '确定编辑该用户吗?',
		quedingyaoxinzenggaiyonghuma: '确定新增该用户吗?',
		denglu: 'Masuk',
		workbench: '工作台',
		analysis: '分析页',
		dashboard: 'Dasbor',
		wushuju: 'Tidak ada data',
	},
	xianggang: 'Hong Kong',
	zhongguo: 'Tiongkok'
};
